import { isNull } from 'utils/tsHelpers';
import { useSearchFieldContext } from '../../context/SearchFieldContext';

export const useIsNoOptionSelected = () => {
  const { option } = useSearchFieldContext();
  return isNull(option);
};
